<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	let {
		tag = 'div',
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
		tag?: 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	} = $props()
</script>

<svelte:element
	this={tag}
	bind:this={ref}
	class={cn(
		'text-base leading-snug font-medium group-data-[size=sm]/card:text-sm group-data-[size=xs]/card:text-xs',
		className
	)}
	data-slot="card-title"
	{...restProps}
>
	{@render children?.()}
</svelte:element>
